<script setup lang="ts">
    import { useRoute } from 'vue-router';
    import { inject, onMounted, ref } from 'vue';
import { formatAmount, formatDate, formatDateFrench } from '@/utils';

    const BACKEND_URL = inject('BACKEND_URL');
    const route = useRoute();
    const user: any = route.meta.user;
    const souscription: any = route.meta.souscription;
    const prelevements = route.meta.prelevements as any[];
    const plan_mensuel: any = route.meta.plan_mensuel;
    const carte: any = route.meta.carte;
    const loading = ref(false);
    const errorMessage = ref('');

    onMounted(() => {
        console.log(plan_mensuel);
    });


</script>
<template>
    <section class="container-full-1 bg-grey-50">
        <div class="page-space-40"></div>

        <h4 class="s7 font-semibold px-3 pb-5">Membre / Plan Mensuel <span class="text-sm text-grey-500"></span></h4>
        <div class="s13 flex-right gap-3 mt--2 mb-5 px-5">
            <span class="btn shadow-200 white2">Prélèvement</span>
            <span class="btn shadow-200 light2 border-none">Données financières</span>
            <span class="btn shadow-200 light2 border-none">Plan Mensuel 1</span>
        </div>

        <!--User info - Component-->
        <div class="s20 widget flex align-items-center px-1 py-5">
            <div class="s2_mobile h-100p px-7">
                <div class="rounded-100 overflow-hidden item active"><!--active-->
                    <img :src="!!user.photo_url ? user.photo_url : '/assets/users_avatar/600w/user.jpg'" width="100%" />
                </div>
            </div>
            <div class="s4_mobile h-100p px-2">
                <h3 class="mb-2">C788PMKJ</h3>
                <h4>{{ user.nom + ' ' + user.prenom }}</h4>
            </div>
            <div class="s3_mobile h-100p px-2">
                <h4 class="font-normal mb-5">{{ user.collectivite?.nom }}</h4>
                <span class="tag-state warning stroke">En cours</span>
                <span class="tag-state notif stroke">Actif</span>
            </div>
            <div class="s4_mobile h-100p px-3">
                <h4 class="font-normal">
                    Date de fin de souscription <br class="mb-2"/>
                    <b class="text-2xl">{{ souscription ? formatDateFrench(souscription.date_fin) : '-' }}</b>
                </h4>
            </div>
            <div class="s7_mobile h-100p px-5">
                <!--Barre de progression - Component-->
                <div class="h-60 rounded-100 position-relative" style="width: 100%; background-color: rgba(var(--color-black-rgb), 0.1);">
                    <div class="widget-floating py-0 text-xl flex-right">Utilisation</div>
                    <div class="h-100p flex align-items-center justify-content-left rounded-100 text-2xl px-5 bg-pop-green" style="width: 25%;">
                        25%
                    </div>
                </div>
                <!--End Barre de progression-->
            </div>
        </div>
        <!--End User info-->
        <div class="clear-both h-20"></div>


        <tempate v-if="souscription">
            <!--Prélèvement mensuel - Component-->
            <div class="s20 widget px-6 pt-8 pb-2">
                <div class="s10 mt--4 ml--4 mb-5 collapse-open active">
                    <span class="px-5 py-4 bg-color-black rounded-100 text-xl">
                        <img src="/icons/icon-panel-open.svg" class="size-xs icon-neutral mr-2 collapse-icon-open" alt="" />
                        <img src="/icons/icon-panel-close.svg" class="size-xs icon-neutral mr-2 collapse-icon-close" alt="" />
                        Prélèvement mensuel
                    </span>
                </div>
                <div class="s10 mt--5-5 flex-right">
                    <!-- <button class="btn lg py-3 white2 active">
                        <img src="/icons/icon-consulter.svg" class="btn-icon" alt="" />
                        <span>Plan mensuel</span>
                    </button> -->
                    <button class="btn lg py-3 black active">
                        <img src="/icons/icon-pdf.svg" class="btn-icon" alt="" />
                        <span>Exporter en PDF</span>
                    </button>
                    <button class="btn lg py-3 black active">
                        <img src="/icons/icon-excel.svg" class="btn-icon" alt="" />
                        <span>Exporter en Excel</span>
                    </button>
                </div>

                <div class="s20 items-center gap-6 pb-4 collapse-content active">
                    <div class="clear-both h-20"></div>
                    <!--Barre de progression - Component-->
                    <div class="h-60 rounded-100 position-relative" style="width: 100%; background-color: rgba(var(--color-black-rgb), 0.1);">
                        <div class="widget-floating py-0 text-xl flex-right">25%</div>
                        <div class="h-100p flex align-items-center rounded-100 px-7 bg-pop-green" style="width: 25%;">
                            <h2>250 000 F</h2><h2 class="font-medium"> &nbsp;/ 1 000 000 F</h2>
                        </div>
                    </div>
                    <!--End Barre de progression-->

                    <div class="clear-both h-30"></div>

                    <div class="grid4 px-1">
                        <!--Prélèvement - Component-->
                        <div :class="{'active': prelevement.status_prelevement == 'validated'}" class="widget border border-3 shadow-200 rounded-30 gap-5 px-7 py-5" v-for="(prelevement, index) of prelevements" :key="'prelevement_' + index">
                            <div class="s10">
                                <h6 class="secondary-font font-semibold mb-1">{{ formatDateFrench(prelevement.periode_prelevement) }}</h6>
                                <h3 class="secondary-font font-semibold text-grey-900 py-1">{{ formatAmount(prelevement.montant_prelevement_expected) }} F</h3>
                            </div>
                            <div class="s10 text-right">
                                <h5 class="secondary-font font-semibold text-grey-600 pb-2" v-if="prelevement.status_prelevement == 'pending'">{{ prelevement.eta }}</h5>
                                <div class="mb-4" v-if="prelevement.status_prelevement == 'validated'">
                                    <span class="tag-state notif stroke">Effectué</span>
                                </div>
                                <h6 class="secondary-font font-semibold text-grey-600 pt-1 mb-4" v-if="prelevement.status_prelevement == 'validated'">Le 11 Déc. 2025</h6>
                                <!-- <button class="btn-ultra w-100 shadow-0 display-none">
                                    <div class="btn-show">
                                        <img src="/icons/icon-valider.svg" class="btn-icon" alt="" />
                                        <span>Valider</span>
                                    </div>
                                    <div class="btn-loading">
                                        <div class="loader-dots"></div>
                                    </div>
                                </button> -->
                            </div>
                        </div>
                        <!--End Prélèvement-->
                    </div>
                    
                    <div class="clear-both h-20"></div>
                    <div class="clear-both h-15"></div>
                    <span class="px-5 py-4 bg-color rounded-100 font-bold text-lg collapse-open active align-right">
                        <img src="/icons/icon-panel-open.svg" class="size-xs icon-neutral mr-2 collapse-icon-open" alt="" />
                        <img src="/icons/icon-panel-close.svg" class="size-xs icon-neutral mr-2 collapse-icon-close" alt="" />
                        Voir tous
                    </span>
                </div>

            </div>

            <div class="clear-both h-5"></div>
            <div class="step vertical bg-grey-500 ml-auto mr-auto"></div>
            <div class="clear-both h-5"></div>


            <!--Données financières   - Component-->
            <div class="s20 widget px-6 pt-8 pb-2">
                <div class="s10 mt--4 ml--4 mb-5 collapse-open active">
                    <span class="px-5 py-4 bg-color-black rounded-100 text-xl">
                        <img src="/icons/icon-panel-open.svg" class="size-xs icon-neutral mr-2 collapse-icon-open" alt="" />
                        <img src="/icons/icon-panel-close.svg" class="size-xs icon-neutral mr-2 collapse-icon-close" alt="" />
                        Données financières
                    </span>
                </div>
                <div class="s10 mt--5-5 flex-right gap-3">
                    <!-- <button class="btn lg py-3 white2 active">
                        <img src="/icons/icon-consulter.svg" class="btn-icon" alt="" />
                        <span>Carte</span>
                    </button>
                    <button class="btn lg py-3 white2 active">
                        <img src="/icons/icon-consulter.svg" class="btn-icon" alt="" />
                        <span>Plan mensuel</span>
                    </button> -->
                </div>
                <div class="clear-both h-5"></div>

                    <div class="s20 items-center gap-6 px-5 pb-6 collapse-content active">

                        <div class="s20 flex gap-5">
                            <div class="s6_mobile">
                                <!--CardCarteLight-->
                                <!-- <div class="card-carte-light">
                                    <div class="card-carte-floating right-bottom">
                                        <div>
                                            <h6 class="secondary-font font-bold">Solde utilisable</h6>
                                            <div class="flex align-items-center gap-2">
                                                <h1 class="secondary-font text-5xl">25 600</h1>
                                                <h2 class="secondary-font text-3xl">F</h2>
                                                <div>
                                                    <img src="/icons/icon-eye-off.svg" class="size-medium icon-white" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <img src="/images/carte_coop.png" class="card-carte-img"/>
                                </div> -->
                                <!---->

                                <!--CardCarte-->
                                <div class="card-carte">
                                    <div class="card-carte-floating">
                                        <div class="s20" v-if="carte">
                                            <h5 class="secondary-font font-bold mb-3">Solde utilisable</h5>
                                            <div class="flex align-items-center gap-2">
                                                <h1 class="secondary-font text-6xl">{{ formatAmount(carte.solde) }}</h1>
                                                <h2 class="secondary-font text-4xl mt-2">F</h2>
                                                <div class="mt-2 ml-2">
                                                    <img src="/icons/icon-eye-off.svg" class="size-medium icon-white" />
                                                </div>
                                            </div>
                                            <div class="card-carte-floating-bottom">
                                                <h5 class="s10 secondary-font font-bold">{{ carte.numero_masque }}</h5>
                                                <div class="s10 flex-right align-items-center gap-2">
                                                    <img src="/icons/icon-edit.svg" class="size-medium icon-white" />
                                                    <h5 class="secondary-font font-bold">Commerce</h5>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="s20" v-if="!carte">
                                            <h5 class="secondary-font font-bold mb-3">Aucune carte disponible</h5>
                                        </div>
                                    </div>
                                    <img src="/images/carte_coop_light.png" class="card-carte-img"/>
                                </div>
                                <!---->

                            </div>
                            <!-- <div class="flex-center">
                                <hr class="hr-vertical h-100p"/>
                            </div> -->
                            <div class="s7_mobile px-6" :class="{'s7_mobile': carte, 's10_mobile': !carte}">
                                <h4 class="font-normal text-grey-500 text-center py-3">
                                    Salaire <br class="mb-4"/>
                                    <b class="text-3xl text-grey-800">{{ formatAmount(souscription.salaire) }}</b>
                                </h4>
                                <hr/>
                                <h4 class="font-normal text-grey-500 text-center py-3">
                                    Prélèvement sur salaire <br class="mb-4"/>
                                    <b class="text-3xl text-grey-800">{{ souscription.prelevement_pourcent }}%</b>
                                </h4>
                                <hr/>
                                <h4 class="font-normal text-grey-500 text-center py-3">
                                    Prêt en Concession<br class="mb-4"/>
                                    <b class="text-3xl text-grey-800">{{ formatAmount(souscription.pret_concession) }}</b>
                                </h4>
                                <hr/>
                            </div>
                            <!-- <div class="flex-center">
                                <hr class="hr-vertical h-100p"/>
                            </div> -->

                            <div class="s7_mobile px-6">
                                <h4 class="font-normal text-grey-500 text-center py-3">
                                    Quote Sessible<br class="mb-4"/>
                                    <b class="text-3xl text-grey-800">20%</b>
                                </h4>
                                <hr/>
                                <h4 class="font-normal text-grey-500 text-center py-3">
                                    Prelevement Solde operée<br class="mb-4"/>
                                    <b class="text-3xl text-grey-800">64.190 F CFA</b>
                                </h4>
                                <hr/>
                                <h4 class="font-normal text-grey-500 text-center py-3">
                                    Prel. Solde % sur Salaire<br class="mb-4"/>
                                    <b class="text-3xl text-grey-800">20%</b>
                                </h4>
                                <hr/>
                            </div>
                        </div>

                        <!-- <div class="clear-both h-20"></div>
                        <hr/> -->

                    </div>

                    <div class="s20 collapse-content pb-7 active">
                        <div class="s6 px-8">
                            <h4 class="font-normal text-grey-500 text-center py-3">
                                Taux Interets Microfinance<br class="mb-4"/>
                                <b class="text-3xl text-grey-800">8,5%</b>
                            </h4>
                            <hr/>
                            <h4 class="font-normal text-grey-500 text-center py-3">
                                Pret à Remburser apres 3 Ans:<br class="mb-4"/>
                                <b class="text-3xl text-grey-800">2.310.840 F CFA</b>
                            </h4>
                            <hr/>
                            <h4 class="font-normal text-grey-500 text-center py-3">
                                Cash-Back TVA Attendu<br class="mb-4"/>
                                <b class="text-3xl text-grey-800">360.000 F CFA</b>
                            </h4>
                        </div>
                        <div class="s7 px-8">
                            <h4 class="font-normal text-grey-500 text-center py-3">
                                Prélèvement à la Solde<br class="mb-4"/>
                                <b class="text-3xl text-grey-800">{{ formatAmount(souscription.prelevement_solde) }}</b>
                            </h4>
                            <hr/>
                            <h4 class="font-normal text-grey-500 text-center py-3">
                                Pret à Rembourser<br class="mb-4"/>
                                <b class="text-3xl text-grey-800">{{ formatAmount(souscription.pret_rembourser) }}</b>
                            </h4>
                            <hr/>
                            <h4 class="font-normal text-grey-500 text-center py-3">
                                Ans pour la Retraite<br class="mb-4"/>
                                <b class="text-3xl text-grey-800">18 ans</b>
                            </h4>
                        </div>
                        <div class="s7 px-8">
                            <h4 class="font-normal text-grey-500 text-center py-3">
                                Pouvoir Achat 1 An<br class="mb-4"/>
                                <b class="text-3xl text-grey-800">{{ formatAmount(souscription.pouvoir_achat_an) }}</b>
                            </h4>
                            <hr/>
                            <h4 class="font-normal text-grey-500 text-center py-3">
                                Pouvoir Achat 3 Ans<br class="mb-4"/>
                                <b class="text-3xl text-grey-800">{{ formatAmount(parseFloat(souscription.pouvoir_achat_an) * 3) }}</b>
                            </h4>
                            <hr/>
                            <h4 class="font-normal text-grey-500 text-center py-3">
                                Durée Financement <br class="mb-4"/>
                                <b class="text-3xl text-grey-800">{{ souscription.duree_mois }} Mois</b> - <b class="text-3xl text-grey-800">{{ parseInt((parseInt(souscription.duree_mois) / 12).toString()) }} ans</b>
                            </h4>
                        </div>
                    </div>

            </div>
         </tempate>
        <div class="s20 widget shadow-100 px-5 py-4 text-center" v-if="!plan_mensuel.data"><!-- widget shadow-100 fill -->
            <span class="font-semibold text-xl">
                Aucune données financières disponibles
            </span>
        </div>

        <div class="clear-both h-5"></div>
        <div class="step vertical bg-grey-500 ml-auto mr-auto"></div>
        <div class="clear-both h-5"></div>


        <!----->
        <!--*** Plan mensuel  Widget *** -->
        <div class="s20 widget shadow-100 pb-1" v-if="plan_mensuel.data"><!-- widget shadow-100 fill -->

            <div class="mt-6 ml-4 mb-5 collapse-open active">
                <span class="px-5 py-4 bg-color-black rounded-100 text-xl">
                    <img src="/icons/icon-panel-open.svg" class="size-xs icon-neutral mr-2 collapse-icon-open" alt="" />
                    <img src="/icons/icon-panel-close.svg" class="size-xs icon-neutral mr-2 collapse-icon-close" alt="" />
                    Plan Mensuel 1
                </span>
            </div>
            
            <div class="s20 pb-7 collapse-content active">
                <div class="container-full-2 s20 mb-5">
                    <div class="s7"><h4 class="font-semibold mt-3">Année 1 / Janv 2026 - Déc 2026</h4></div>
                    <div class="s13 flex gap-2 justify-content-right">
                        <button class="btn black normal justify-content-center mx-0 btn-filtre">
                            <img src="/icons/icon-pdf.svg" class="btn-icon" alt="" />
                            <span>Exporter PDF</span>
                        </button>
                        <button class="btn black normal justify-content-center mx-0 btn-filtre">
                            <img src="/icons/icon-excel.svg" class="btn-icon" alt="" />
                            <span>Exporter Excel</span>
                        </button>
                    </div>
                </div>

                <table class="table separator skin1 sm selection text-right">
                    <thead>
                        <tr>
                            <th class="mode text-left pl-5">Mois</th>
                            <th>1</th>
                            <th>2</th>
                            <th>3</th>
                            <th>4</th>
                            <th>5</th>
                            <th>6</th>
                            <th>7</th>
                            <th>8</th>
                            <th>9</th>
                            <th>10</th>
                            <th>11</th>
                            <th>12</th>
                            <th class="font-semibold pr-5">Total</th>
                        </tr>
                        <tr>
                            <th class="mode text-left py-5 pl-5">&nbsp;</th>
                            <th v-for="(column, index) of plan_mensuel.columns" :key="index">{{ column }}</th>
                            <th class="font-semibold pr-5"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="mode text-left pl-5">Décaissement</td>
                            <td v-for="(data, index) of plan_mensuel.data['_DECAISSEMENT_']" :key="index">{{ formatAmount(data) }}</td>
                            <td class="font-semibold pr-5">{{ formatAmount(plan_mensuel['totals']['_DECAISSEMENT_']) }}</td>
                        </tr>
                        <tr>
                            <td class="mode text-left pl-5">25% Fond de risque</td>
                            <td class="text-red" v-for="(data, index) of plan_mensuel.data['_FOND_RISQUE_']" :key="index">{{ formatAmount(data) }}</td>
                            <td class="font-semibold text-red pr-5">{{ formatAmount(plan_mensuel['totals']['_FOND_RISQUE_']) }}</td>
                        </tr>
                        <tr>
                            <td class="mode text-left pl-5">Crédits Mensuels</td>
                            <td class="" v-for="(data, index) of plan_mensuel.data['_CREDITS_MENSUELS_']" :key="index">{{ formatAmount(data) }}</td>
                            <td class="font-semibold pr-5">{{ formatAmount(plan_mensuel['totals']['_CREDITS_MENSUELS_']) }}</td>
                        </tr>
                        <tr>
                            <td class="mode text-left pl-5">Frais mensuels: 5%</td>
                            <td class="text-red" v-for="(data, index) of plan_mensuel.data['_FRAIS_MENSUELS_']" :key="index">{{ formatAmount(data) }}</td>
                            <td class="font-semibold text-red pr-5">{{ formatAmount(plan_mensuel['totals']['_FRAIS_MENSUELS_']) }}</td>
                        </tr>
                        <tr>
                            <td class="mode text-left pl-5">Renfourement: 30%</td>
                            <td class="text-red" v-for="(data, index) of plan_mensuel.data['_RENFOUREMENT_']" :key="index">{{ formatAmount(data) }}</td>
                            <td class="font-semibold text-red pr-5">{{ formatAmount(plan_mensuel['totals']['_RENFOUREMENT_']) }}</td>
                        </tr>
                        <tr>
                            <td class="mode text-left pl-5">Revolving Recharge</td>
                            <td v-for="(data, index) of plan_mensuel.data['_REVOLVING_']" :key="index">{{ formatAmount(data) }}</td>
                            <td class="font-semibold pr-5">{{ formatAmount(plan_mensuel['totals']['_REVOLVING_']) }}</td>
                        </tr>
                        <tr>
                            <td class="mode text-left pl-5">Cash-Back TVA</td>
                            <td v-for="(data, index) of plan_mensuel.data['_CASHBACK_TVA_']" :key="index">{{ formatAmount(data) }}</td>
                            <td class="font-semibold pr-5">{{ formatAmount(plan_mensuel['totals']['_CASHBACK_TVA_']) }}</td>
                        </tr>
                        <tr>
                            <td class="text-lg font-semibold py-5 text-left pl-5">Utilisation</td>
                            <td v-for="(data, index) of plan_mensuel.data['_UTILISATION_']" :key="index">{{ formatAmount(data) }}</td>
                            <td class="text-lg font-semibold text-red pr-5">{{ formatAmount(plan_mensuel['totals']['_UTILISATION_']) }}</td>
                        </tr>
                        <tr>
                            <td class="font-bold text-left pl-5">Index Utilisation</td>
                            <td v-for="(data, index) of plan_mensuel.data['_UTILISATION_INDEX_']" :key="index">{{ formatAmount(data) }}</td>
                            <td class="text-lg font-semibold text-red pr-5">{{ formatAmount(plan_mensuel['totals']['_UTILISATION_INDEX_']) }}</td>
                        </tr>
                        <tr>
                            <td class="font-bold text-left pl-5">Index Cumulé</td>
                            <td v-for="(data, index) of plan_mensuel.data['_UTILISATION_CUMUL_']" :key="index">{{ formatAmount(data) }}</td>
                            <td class="font-semibold pr-5">{{ formatAmount(plan_mensuel['totals']['_UTILISATION_CUMUL_']) }}</td>
                        </tr>
                        <tr>
                            <td class="mode text-left pl-5">Depenses Mensuels</td>
                            <td class="text-red" v-for="(data, index) of plan_mensuel.data['_DEPENSES_MENSUELS_']" :key="index">{{ formatAmount(data) }}</td>
                            <td class="font-semibold text-red pr-5">{{ formatAmount(plan_mensuel['totals']['_DEPENSES_MENSUELS_']) }}</td>
                        </tr>
                        <tr style="background-color: #e7ffd6;">
                            <td class="font-semibold text-blue text-left py-4 pl-5">Crédit Epargne</td>
                            <td class="font-semibold text-blue" v-for="(data, index) of plan_mensuel.data['_CREDIT_EPARGNE_']" :key="index">{{ formatAmount(data) }}</td>
                            <td class="font-semibold text-blue pr-5">{{ formatAmount(plan_mensuel['totals']['_CREDIT_EPARGNE_']) }}</td>
                        </tr>
                        <tr>
                            <td class="font-semibold text-left py-5 pl-5">Solde Total Cash Flow</td>
                            <td class="font-semibold" v-for="(data, index) of plan_mensuel.data['_SOLDE_TOTAL_CASHFLOW_']" :key="index">{{ formatAmount(data) }}</td>
                            <td class="font-semibold pr-5"></td>
                        </tr>
                        <tr style="background-color: #eefde3;">
                            <td class="text-lg font-semibold text-green text-left py-5 pl-5">Utilisation By Index</td>
                            <td class="text-lg font-semibold text-green" v-for="(data, index) of plan_mensuel.data['_UTILISATION_BY_INDEX_']" :key="index">{{ formatAmount(data) }}</td>
                            <td class="text-lg font-semibold text-green pr-5">{{ formatAmount(plan_mensuel['totals']['_UTILISATION_BY_INDEX_']) }}</td>
                        </tr>
                        <tr>
                            <td class="text-lg font-semibold text-blue text-left py-5 pl-5">Progressive</td>
                            <td class="text-lg font-semibold text-blue" v-for="(data, index) of plan_mensuel.data['_PROGRESSIVE_']" :key="index">{{ formatAmount(data) }}</td>
                            <td class="text-lg font-semibold text-blue pr-5"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="s20 widget shadow-100 px-5 py-4 text-center" v-if="!plan_mensuel.data"><!-- widget shadow-100 fill -->
            <span class="font-semibold text-xl">
                Aucun plan mensuel disponible
            </span>
        </div>
        <div class="clear-both h-80"></div>

    </section>
</template>